import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";
import config from "./aws-config";

const userPool = new CognitoUserPool({
  UserPoolId: config.cognito.userPoolId,
  ClientId: config.cognito.clientId,
});

// Tente de récupérer une session existante (token refresh automatique)
export function getCurrentSession() {
  return new Promise((resolve) => {
    const user = userPool.getCurrentUser();
    if (!user) return resolve(null);

    user.getSession((err, session) => {
      if (err || !session || !session.isValid()) return resolve(null);
      resolve({
        token: session.getIdToken().getJwtToken(),
        groups:
          session.getIdToken().payload["cognito:groups"] || [],
        email: session.getIdToken().payload.email,
      });
    });
  });
}

export function login(email, password) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({
      Username: email,
      Pool: userPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: email,
      Password: password,
    });

    user.authenticateUser(authDetails, {
      onSuccess: (session) => {
        resolve({
          token: session.getIdToken().getJwtToken(),
          groups:
            session.getIdToken().payload["cognito:groups"] || [],
          email: session.getIdToken().payload.email,
        });
      },
      onFailure: (err) => {
        reject(err);
      },
      newPasswordRequired: (userAttributes) => {
        // Premier login avec mot de passe temporaire
        // On retire les attributs en lecture seule
        delete userAttributes.email_verified;
        delete userAttributes.email;
        resolve({
          newPasswordRequired: true,
          user,
          userAttributes,
        });
      },
    });
  });
}

export function completeNewPassword(user, newPassword, userAttributes) {
  return new Promise((resolve, reject) => {
    user.completeNewPasswordChallenge(newPassword, userAttributes, {
      onSuccess: (session) => {
        resolve({
          token: session.getIdToken().getJwtToken(),
          groups:
            session.getIdToken().payload["cognito:groups"] || [],
          email: session.getIdToken().payload.email,
        });
      },
      onFailure: (err) => {
        reject(err);
      },
    });
  });
}

export function logout() {
  const user = userPool.getCurrentUser();
  if (user) user.signOut();
}
